export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Ich hatte Angst vor Koreanisch. Alle diese Symbole schienen unmöglich. Nach Tag 5 mit K-Visual Masterplan™ konnte ich meinen ersten Satz in Hangeul ohne Hilfe lesen. In Woche 3 sah ich K-Dramen und verstand echte Wörter. Dieses System hat mein Leben komplett verändert.',
    name: 'Marie D.',
    location: 'Berlin · Deutschland',
    flag: '🇩🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/362d210d-32c8-42e9-94ff-bc4f4952fd79.jpg',
  },
  {
    quote:
      'Ich sah K-Dramen seit 2 Jahren und war frustriert, weil ich NICHTS verstand. Ich versuchte 6 Monate eine App ohne echten Fortschritt. Die K-Visual Masterplan™-Methode funktioniert wirklich. Ich bin jetzt in der Discord-Community und spreche mit echten Koreanern.',
    name: 'Thomas L.',
    location: 'München · Deutschland',
    flag: '🇩🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/80848e14-15f4-430a-9b92-68ab90c6b61e.jpg',
  },
  {
    quote:
      'Ich hatte Angst, nicht „begabt für Sprachen“ zu sein. K-Visual Masterplan™ hat mir das Gegenteil bewiesen. Die visuelle Methode macht alles so klar. Ich spürte Fortschritt AB TAG EINS, was mich motivierte. Ich empfehle es allen K-Pop-Fans, die ich kenne.',
    name: 'Sophie B.',
    location: 'Hamburg · Deutschland',
    flag: '🇩🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/880ec9f6-323a-450b-80d1-71b8a76c1a33.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'Die Flashcards leben jetzt auf meinem Handy. Ich wiederhole Hangeul in der U-Bahn und lese bereits Menüs und Schilder in K-Dramen, bevor die Untertitel erscheinen.',
    name: 'Julia M.',
    location: 'Köln · Deutschland',
    flag: '🇩🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7403b0e6-4b72-48c1-9192-410f031e00ab.jpg',
  },
  {
    quote:
      'Hangeul hat es in zwei Abenden geschafft. Ich hatte es vorher dreimal mit Videos versucht und immer aufgegeben. Die Silbenblöcke visuell erklärt zu sehen, hat endlich klick gemacht.',
    name: 'Lukas R.',
    location: 'Frankfurt · Deutschland',
    flag: '🇩🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/81425cb1-d010-4002-b9db-3ff420402612.jpg',
  },
  {
    quote:
      'Die 60-Minuten-Routine hat mich konstant gehalten. Jeden Tag klar, was zu lernen ist, kein Zweifel. An Tag 55 habe ich meine erste Nachricht auf Koreanisch an einen Freund in Seoul geschickt.',
    name: 'Jonas P.',
    location: 'Stuttgart · Deutschland',
    flag: '🇩🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/47b0264e-cbb6-45c9-bff8-6a1a4a2fd195.jpg',
  },
  {
    quote:
      'Ich habe es für K-Pop-Songtexte gekauft und bin wegen der Community geblieben. Dort korrigieren Muttersprachler deine Aussprache. Das ist weit mehr als 19€ wert.',
    name: 'Lena Z.',
    location: 'Leipzig · Deutschland',
    flag: '🇩🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/fe614a6f-eaed-43fd-ab74-bd42110ca59c.jpg',
  },
];
